import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Form, Input, Button, Typography, message } from 'antd';
import '../../components/common.css';

const { Title, Text } = Typography;

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=DM+Sans:wght@300;400;500&display=swap');

  .chpw-root {
    min-height: 100vh;
    background: #ffffff;
    display: flex;
    font-family: 'DM Sans', sans-serif;
    overflow: hidden;
  }

  /* Left decorative panel */
  .chpw-left {
    width: 48%;
    background: #485daa;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 60px 48px;
  }

  .chpw-left::before {
    content: '';
    position: absolute;
    top: -120px;
    left: -120px;
    width: 420px;
    height: 420px;
    background: rgba(255,255,255,0.06);
    border-radius: 50%;
  }

  .chpw-left::after {
    content: '';
    position: absolute;
    bottom: -80px;
    right: -100px;
    width: 320px;
    height: 320px;
    background: rgba(255,255,255,0.05);
    border-radius: 50%;
  }

  .chpw-left-dot {
    position: absolute;
    top: 40px;
    right: 40px;
    width: 12px;
    height: 12px;
    background: rgba(255,255,255,0.4);
    border-radius: 50%;
  }

  .chpw-left-dot2 {
    position: absolute;
    bottom: 60px;
    left: 50px;
    width: 8px;
    height: 8px;
    background: rgba(255,255,255,0.25);
    border-radius: 50%;
  }

  .chpw-left-grid {
    position: absolute;
    inset: 0;
    background-image:
      linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
    background-size: 48px 48px;
  }

  .chpw-left-content {
    position: relative;
    z-index: 2;
    text-align: left;
    width: 100%;
  }

  .chpw-tagline {
    font-family: 'Sora', sans-serif;
    font-size: 36px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.25;
    margin-bottom: 20px;
    letter-spacing: -0.5px;
  }

  .chpw-tagline span {
    color: rgba(255,255,255,0.45);
  }

  .chpw-sub {
    font-size: 15px;
    color: rgba(255,255,255,0.65);
    line-height: 1.7;
    max-width: 320px;
    font-weight: 300;
  }

  .chpw-tips {
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .chpw-tip {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 12px;
    padding: 14px 18px;
    backdrop-filter: blur(8px);
  }

  .chpw-tip-icon {
    width: 32px;
    height: 32px;
    background: rgba(255,255,255,0.15);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 1px;
  }

  .chpw-tip-icon svg {
    width: 15px;
    height: 15px;
    color: white;
  }

  .chpw-tip-text {
    font-size: 13px;
    color: rgba(255,255,255,0.8);
    font-weight: 400;
    line-height: 1.5;
  }

  /* Right form panel */
  .chpw-right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 48px;
    background: #ffffff;
  }

  .chpw-form-wrap {
    width: 100%;
    max-width: 400px;
  }

  .chpw-logo-area {
    margin-bottom: 40px;
  }

  .chpw-logo-area img {
    width: 150px;
    height: auto;
    object-fit: contain;
    display: block;
  }

  .chpw-heading {
    font-family: 'Sora', sans-serif;
    font-size: 26px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 6px 0;
    letter-spacing: -0.3px;
  }

  .chpw-subheading {
    font-size: 14px;
    color: #9ca3af;
    font-weight: 400;
    margin-bottom: 36px;
    display: block;
  }

  .chpw-label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    letter-spacing: 0.2px;
  }

  .chpw-input-wrap .ant-input-password,
  .chpw-input-wrap .ant-input-affix-wrapper {
    border-radius: 10px !important;
    border: 1.5px solid #e5e7eb !important;
    background: #fafafa !important;
    font-size: 14px !important;
    height: 46px !important;
    transition: all 0.2s !important;
    box-shadow: none !important;
    font-family: 'DM Sans', sans-serif !important;
    padding: 0 14px !important;
    align-items: center !important;
  }

  .chpw-input-wrap .ant-input-affix-wrapper input {
    height: auto !important;
    border: none !important;
    background: transparent !important;
  }

  .chpw-input-wrap .ant-input-affix-wrapper:focus,
  .chpw-input-wrap .ant-input-affix-wrapper-focused {
    border-color: #485daa !important;
    background: #ffffff !important;
    box-shadow: 0 0 0 3px rgba(72, 93, 170, 0.1) !important;
  }

  .chpw-input-wrap .ant-input-affix-wrapper:hover {
    border-color: #485daa !important;
  }

  .chpw-strength-note {
    background: #f8f9ff;
    border: 1px solid #e8ebf8;
    border-radius: 10px;
    padding: 12px 16px;
    margin-bottom: 24px;
    font-size: 13px;
    color: #6b7280;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    line-height: 1.5;
  }

  .chpw-strength-note svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: #485daa;
    margin-top: 1px;
  }

  .chpw-btn-row {
    display: flex;
    gap: 12px;
    margin-top: 8px;
  }

  .chpw-btn-primary {
    flex: 1;
    height: 48px !important;
    border-radius: 10px !important;
    font-weight: 600 !important;
    font-size: 15px !important;
    background: #485daa !important;
    border-color: #485daa !important;
    letter-spacing: 0.2px !important;
    font-family: 'Sora', sans-serif !important;
    transition: all 0.25s ease !important;
    box-shadow: 0 4px 16px rgba(72, 93, 170, 0.3) !important;
  }

  .chpw-btn-primary:hover {
    background: #3a4d96 !important;
    border-color: #3a4d96 !important;
    box-shadow: 0 6px 20px rgba(72, 93, 170, 0.4) !important;
    transform: translateY(-1px);
  }

  .chpw-btn-ghost {
    height: 48px !important;
    border-radius: 10px !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    border-color: #e5e7eb !important;
    color: #6b7280 !important;
    font-family: 'DM Sans', sans-serif !important;
    transition: all 0.2s ease !important;
  }

  .chpw-btn-ghost:hover {
    border-color: #485daa !important;
    color: #485daa !important;
  }

  @media (max-width: 768px) {
    .chpw-left { display: none; }
    .chpw-right { padding: 40px 24px; }
  }
`;

const LockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

const ChangePasswordPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      await axios.put(`${API_URL}/users/${userId}/change-password`, {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setLoading(false);
      message.success('Password changed successfully');
      navigate('/dashboard');
    } catch (error) {
      setLoading(false);
      if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else {
        message.error('Failed to change password. Please try again.');
      }
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="chpw-root">

        {/* Left Decorative Panel */}
        <div className="chpw-left">
          <div className="chpw-left-grid" />
          <div className="chpw-left-dot" />
          <div className="chpw-left-dot2" />

          <div className="chpw-left-content">
            <div className="chpw-tagline">
              Keep your<br />
              account <span>secure.</span>
            </div>
            <p className="chpw-sub">
              Regular password updates help protect your data and keep your school management safe.
            </p>

            <div className="chpw-tips">
              <div className="chpw-tip">
                <div className="chpw-tip-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <span className="chpw-tip-text">Use at least 8 characters with a mix of letters and numbers</span>
              </div>
              <div className="chpw-tip">
                <div className="chpw-tip-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <span className="chpw-tip-text">Avoid reusing passwords from other accounts</span>
              </div>
              <div className="chpw-tip">
                <div className="chpw-tip-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <span className="chpw-tip-text">Never share your password with anyone, including administrators</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Form Panel */}
        <div className="chpw-right">
          <div className="chpw-form-wrap">

            <div className="chpw-logo-area">
              <img src="/images/plann_logo.png" alt="Logo" />
            </div>

            <h2 className="chpw-heading">Change Password</h2>
            <span className="chpw-subheading">Enter your current password and choose a new one</span>

            <Form
              form={form}
              name="changePassword"
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
              className="chpw-input-wrap"
            >
              <Form.Item
                name="currentPassword"
                label={<span className="chpw-label">Current Password</span>}
                rules={[{ required: true, message: 'Please input your current password!' }]}
                style={{ marginBottom: 20 }}
              >
                <Input.Password
                  size="large"
                  placeholder="Enter your current password"
                  prefix={<LockIcon />}
                />
              </Form.Item>

              <Form.Item
                name="newPassword"
                label={<span className="chpw-label">New Password</span>}
                rules={[
                  { required: true, message: 'Please input your new password!' },
                  { min: 8, message: 'Password must be at least 8 characters' },
                ]}
                style={{ marginBottom: 20 }}
              >
                <Input.Password
                  size="large"
                  placeholder="Enter your new password"
                  prefix={<LockIcon />}
                />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label={<span className="chpw-label">Confirm New Password</span>}
                dependencies={['newPassword']}
                hasFeedback
                rules={[
                  { required: true, message: 'Please confirm your new password!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('newPassword') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Passwords do not match!'));
                    },
                  }),
                ]}
                style={{ marginBottom: 24 }}
              >
                <Input.Password
                  size="large"
                  placeholder="Confirm your new password"
                  prefix={<LockIcon />}
                />
              </Form.Item>

              <div className="chpw-strength-note">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                Use at least 8 characters with a mix of letters, numbers, and symbols for a stronger password.
              </div>

              <div className="chpw-btn-row">
                <Button
                  onClick={() => navigate('/dashboard')}
                  className="chpw-btn-ghost"
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  className="chpw-btn-primary"
                >
                  Update Password
                </Button>
              </div>
            </Form>
          </div>
        </div>

      </div>
    </>
  );
};

export default ChangePasswordPage;